var React = require('react');

function S01 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Beauty_Salon","data-name":"Beauty Salon","transform":"translate(0.364 0)"},[React.createElement("rect",{"id":"Rectangle_48744","data-name":"Rectangle 48744","width":"28","height":"28","transform":"translate(-0.364 0)","fill":"none","key":0}),React.createElement("path",{"id":"Path_106686","data-name":"Path 106686","d":"M13.341,2.453a.7.7,0,0,0-.433.26l-3,2.343a2,2,0,0,0-.471,1.315V9.052h-.8a.808.808,0,0,0-.8.82V23.926a.808.808,0,0,0,.8.82H15.1a.808.808,0,0,0,.8-.82V9.872a.808.808,0,0,0-.8-.82h-.8V3.364a.844.844,0,0,0-.942-.911ZM9.446,10.7H14.3v7.442H9.446Zm0,9.1H14.3v3.306H9.446Z","transform":"translate(2.135 0.407)","key":1})]));
}

S01.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = S01;

S01.default = S01;
